/**
 * MUSKLE ↔ Notify Me! visual/copy polish only.
 * Does not change registration, variant IDs, or channel submit behavior.
 * Copy uses Notify Me! ui_contents field names when present; DOM polish is fallback.
 */
(function () {
  'use strict';

  if (window.__MUSKLE_NOTIFY_ME_POLISH__) return;
  window.__MUSKLE_NOTIFY_ME_POLISH__ = true;

  var NL = {
    form_title: 'Laat mij weten',
    intro: 'Ontvang een bericht zodra deze variant weer op voorraad is.',
    email_label: 'E-mailadres',
    email_input_placeholder: 'E-mailadres',
    email_input_below_text:
      'Geen spam. Alleen een bericht wanneer deze variant weer beschikbaar is.',
    variant_label: 'Variant',
    button_text: 'Houd mij op de hoogte',
    after_subscribe_message_text:
      'Aanvraag ontvangen. Je staat op de lijst. We sturen je een bericht zodra deze variant weer op voorraad is.',
    already_subscribed_message_text:
      'Je staat al op de lijst voor deze variant. We sturen je een bericht zodra die weer op voorraad is.',
  };

  var EN = {
    form_title: 'Notify me',
    intro: 'Get an email when this variant is back in stock.',
    email_label: 'Email address',
    email_input_placeholder: 'Email address',
    email_input_below_text:
      "No spam. We'll only email you when this variant is available again.",
    variant_label: 'Variant',
    button_text: 'Notify me',
    after_subscribe_message_text:
      "Request received. You're on the list. We'll email you when this variant is back in stock.",
    already_subscribed_message_text:
      "You're already on the list for this variant. We'll email you when it's back in stock.",
  };

  function packForLang(lang) {
    var l = String(lang || '').toLowerCase();
    if (l.indexOf('en') === 0) return EN;
    if (l.indexOf('nl') === 0) return NL;
    return null;
  }

  function pagePack() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('en') === 0) return EN;
    return NL;
  }

  function patchUiContents() {
    var cfg = window._ReStockConfig;
    if (!cfg || !Array.isArray(cfg.ui_contents) || !cfg.ui_contents.length) return false;

    cfg.ui_contents.forEach(function (entry) {
      if (!entry || !entry.subscription_form_content) return;
      var pack = packForLang(entry.language);
      if (!pack) return;
      var c = entry.subscription_form_content;
      c.form_title = pack.form_title;
      c.email_label = pack.email_label;
      c.email_input_placeholder = pack.email_input_placeholder;
      c.email_input_below_text = pack.email_input_below_text;
      c.button_text = pack.button_text;
      c.after_subscribe_message_text = pack.after_subscribe_message_text;
      c.already_subscribed_message_text = pack.already_subscribed_message_text;
    });
    return true;
  }

  function setText(el, text) {
    if (!el || text == null) return;
    if (el.textContent !== text) el.textContent = text;
  }

  function ensureNote(parent, className, text, beforeEl) {
    if (!parent || !text) return;
    var node = parent.querySelector('.' + className);
    if (!node) {
      node = document.createElement('p');
      node.className = className;
      if (beforeEl && beforeEl.parentNode === parent) {
        parent.insertBefore(node, beforeEl);
      } else {
        parent.appendChild(node);
      }
    }
    setText(node, text);
  }

  function polishOpenModal() {
    var box = document.querySelector('.restock-alerts-modal-wrapper .restock-alerts-modal-box');
    if (!box || box.getAttribute('data-muskle-notify-polished') === '1') return;
    var pack = pagePack();
    var form = box.querySelector('.restock-alerts-form');
    if (!form) return;

    setText(form.querySelector('.restock-alerts-form-title'), pack.form_title);

    var emailLabelSpan = form.querySelector('.restock-alerts-email-label-span');
    setText(emailLabelSpan, pack.email_label);

    var emailInput = form.querySelector('.restock-alerts-email-input');
    if (emailInput) emailInput.setAttribute('placeholder', pack.email_input_placeholder);

    var submit = box.querySelector('.restock-alerts-submit-button');
    setText(submit, pack.button_text);

    var title = form.querySelector('.restock-alerts-form-title');
    if (title) {
      var intro = form.querySelector('.muskle-notify-intro');
      if (!intro) {
        intro = document.createElement('p');
        intro.className = 'muskle-notify-intro';
        title.insertAdjacentElement('afterend', intro);
      }
      setText(intro, pack.intro);
    }

    var variantWrap = form.querySelector('.selectBoxWrapper');
    if (variantWrap) {
      var vLabel = variantWrap.querySelector('.muskle-notify-variant-label');
      if (!vLabel) {
        vLabel = document.createElement('div');
        vLabel.className = 'muskle-notify-variant-label';
        variantWrap.insertBefore(vLabel, variantWrap.firstChild);
      }
      setText(vLabel, pack.variant_label);
    }

    var lower = box.querySelector('.modalBoxLowerSectionStyle');
    if (lower) {
      ensureNote(lower, 'muskle-notify-small-copy', pack.email_input_below_text, lower.querySelector('.restock-alerts-submit-button'));
    } else {
      ensureNote(form, 'muskle-notify-small-copy', pack.email_input_below_text, null);
    }

    box.setAttribute('data-muskle-notify-polished', '1');
  }

  function watchModal() {
    var root = document.body;
    if (!root) return;
    var obs = new MutationObserver(function () {
      var wrapper = document.querySelector('.restock-alerts-modal-wrapper');
      if (!wrapper) return;
      var box = wrapper.querySelector('.restock-alerts-modal-box');
      if (!box) return;
      /* Modal remounts on reopen — allow polish again. */
      if (!wrapper.contains(box)) return;
      if (box.getAttribute('data-muskle-notify-polished') === '1') return;
      polishOpenModal();
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  function boot() {
    if (!patchUiContents()) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (patchUiContents() || tries > 48) clearInterval(timer);
      }, 250);
    }
    watchModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
